import { LogManager } from '../../../common/port/log/log.manager.port';
import { AppGoalsCubeMetric } from '../../../common/enum/goal/app-goals-cube-metrics.enum';
import { GetSelfScoreAveragesSummaryRequestDto } from '../../dtos/scores/self-get-score-averages-summary.request.dto';
import { GetSelfScoreAveragesSummaryResponseDto } from '../../dtos/scores/self-get-score-averages-summary.response.dto';
import { GetSelfScoreAveragesSummaryPresenter } from '../../presenters/scores/get-self-score-averages-summary.presenter';
import { GetSelfDigitalIntensityScoreAveragesSummaryQuery } from '../../queries/scores/get-self-digital-intensity-score-averages-summary.query';
import { GetSelfDigitalWorkingHoursScoreAveragesSummaryQuery } from '../../queries/scores/get-self-digital-working-hours-score-averages-summary.query';
import { GetSelfFocusScoreAveragesSummaryQuery } from '../../queries/scores/get-self-focus-score-averages-summary.query';
import { GetSelfScreentimeScoreAveragesSummaryQuery } from '../../queries/scores/get-self-screentime-score-averages-summary.query';
import { GetSelfTimeInCallsScoreAveragesSummaryQuery } from '../../queries/scores/get-self-time-in-calls-score-averages-summary.query';
import { GetSelfTimeInMeetingsScoreAveragesSummaryQuery } from '../../queries/scores/get-self-time-in-meetings-score-averages-summary.query';
import { CoreScoreNames } from '../../../common/enum/scores/core-score-name.enum';
export class GetSelfScoreAveragesSummaryCompositeController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly getSelfTimeInMeetingsScoreAveragesSummaryQuery: GetSelfTimeInMeetingsScoreAveragesSummaryQuery,
    protected readonly getSelfTimeInCallsScoreAveragesSummaryQuery: GetSelfTimeInCallsScoreAveragesSummaryQuery,
    protected readonly getSelfDigitalIntensityScoreAveragesSummaryQuery: GetSelfDigitalIntensityScoreAveragesSummaryQuery,
    protected readonly getSelfFocusScoreAveragesSummaryQuery: GetSelfFocusScoreAveragesSummaryQuery,
    protected readonly getSelfScreentimeScoreAveragesSummaryQuery: GetSelfScreentimeScoreAveragesSummaryQuery,
    protected readonly getSelfDigitalWorkingHoursScoreAveragesSummaryQuery: GetSelfDigitalWorkingHoursScoreAveragesSummaryQuery,
    protected readonly presenter: GetSelfScoreAveragesSummaryPresenter
  ) {}

  async get(
    props: GetSelfScoreAveragesSummaryRequestDto
  ): Promise<GetSelfScoreAveragesSummaryResponseDto> {
    try {
      let result;
      if (props.params.score === CoreScoreNames['Time in Meetings']) {
        result =
          await this.getSelfTimeInMeetingsScoreAveragesSummaryQuery.execute(
            props
          );
      }
      if (props.params.score === CoreScoreNames['Time in Calls']) {
        result = await this.getSelfTimeInCallsScoreAveragesSummaryQuery.execute(
          props
        );
      }

      if (props.params.score === CoreScoreNames['Digital Intensity']) {
        result =
          await this.getSelfDigitalIntensityScoreAveragesSummaryQuery.execute(
            props
          );
      }

      if (props.params.score === CoreScoreNames.Focus) {
        result = await this.getSelfFocusScoreAveragesSummaryQuery.execute(
          props
        );
      }

      if (props.params.score === CoreScoreNames.Screentime) {
        result = await this.getSelfScreentimeScoreAveragesSummaryQuery.execute(
          props
        );
      }

      if (props.params.score === CoreScoreNames['Digital Working hours']) {
        result =
          await this.getSelfDigitalWorkingHoursScoreAveragesSummaryQuery.execute(
            props
          );
      }
      return this.presenter.toResponse(result);
    } catch (error) {
      throw new Error(
        `GetSelfGoalSummaryCompositeController.get encountered an error ${error}`
      );
    }
  }
}
